<template>
  <div class="c-home c-main-shadow" v-if="post && posts">
    <div class="c-header-wrap c-flex ac w100">
      <div class="c-post-icon">
        <v-icon>{{ icon }}</v-icon>
      </div>
      <div class="s">
        <div class="c-post-name" :style="maxNameWidth">{{ title }}</div>
      </div>
      <div class="c-btn-edit">
        <v-tooltip bottom>
          <v-btn
            slot="activator"
            class="c-edit-btn"
            flat
            icon
            color="clr-black"
            @click="onEditClicked"
            :disabled="!editable"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <span>{{ $T('common.edit') }}</span>
        </v-tooltip>
      </div>
      <div class="c-btn-exit">
        <v-tooltip bottom>
          <v-btn
            slot="activator"
            class="c-edit-btn"
            flat
            icon
            color="clr-black"
            @click="onDeleteClicked"
            :disabled="!deletable"
          >
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn>
          <span>{{ $T('common.delete') }}</span>
        </v-tooltip>
      </div>
      <div class="c-btn-menu">
        <v-tooltip bottom>
          <v-btn slot="activator" flat icon color="clr-black" @click="$router.push({ name: 'topHome' })">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
          <span>{{ $T('common.list') }}</span>
        </v-tooltip>
      </div>
    </div>

    <div class="content-area">
      <post-detail-news v-if="'NS' == post.type" :initPost="post" @modified="onModified" />
      <post-detail-file v-if="'FL' == post.type" :initPost="post" @modified="onModified" />
      <post-detail-schedule v-if="'SD' == post.type" :initPost="post" @modified="onModified" />
      <post-detail-enquete v-if="'EQ' == post.type" :initPost="post" @modified="onModified" />
      <post-detail-life v-if="'LF' == post.type" :initPost="post" @modified="onModified" />
      <post-detail-accept v-else-if="'JA' == post.type" :initPost="post" @modified="onModified" />
      <post-detail-friend-accept v-else-if="'FA' == post.type" :initPost="post" @modified="onModified" />
      <post-detail-invited v-else-if="'JI' == post.type" :initPost="post" @modified="onModified" />
      <post-detail-friend-invited v-else-if="'FI' == post.type" :initPost="post" @modified="onModified" />
    </div>

    <div class="post-control-area">
      <v-divider />
      <div class="post-control-main">
        <div class="c-flex w100">
          <div>
            <selected-members
              class="c-mems"
              :cid="cid"
              :cIcon="true"
              :memberGroups="shareTargets"
              :creatorCmid="post.creator_cmid"
              :pos="1"
              :showCount="leTbS ? 3 : 10"
              :onlyCreator="onlyCreator"
              :includeInactive="includeInactive"
              iconColor="clr-black"
              :postCreator="{ pid: post.id, cmid: post.creator_cmid, name: post.creator_cm_name }"
              type="post"
              :typeId="post.id"
              :friends="curFriends"
              @memberRequested="onMemberRequested"
            ></selected-members>
            <div class="c-ans">
              <post-answers :initPost="post" type="post" :typeId="post.id" :friends="curFriends" />
            </div>
          </div>
          <div class="s" />
          <div>
            <div class="c-t">{{ unixToDetail(post.post_at) }}</div>
            <div class="c-t c-expire" :class="{ 'clr-danger--text': isPast(post.expire_at) }">
              <v-icon>mdi-timer-sand-empty</v-icon>{{ unixToDetail(post.expire_at) }}
            </div>
          </div>
        </div>
        <div class="c-prev-next c-flex w100">
          <v-tooltip top>
            <v-btn
              :disabled="!prevTodoPid"
              slot="activator"
              :to="{ name: 'postDetail', params: { id: curCid, pid: prevTodoPid } }"
              flat
              icon
              color="clr-black"
              ><v-icon>mdi-chevron-double-left</v-icon></v-btn
            >
            <span>{{ $T('post.arrow.prev_todo') }}</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              :disabled="!prevPid"
              slot="activator"
              :to="{ name: 'postDetail', params: { id: curCid, pid: prevPid } }"
              flat
              icon
              color="clr-black"
              ><v-icon>mdi-chevron-left</v-icon></v-btn
            >
            <span>{{ $T('post.arrow.prev') }}</span>
          </v-tooltip>
          <div class="s" />
          <v-tooltip top>
            <v-btn
              :disabled="!nextPid"
              slot="activator"
              :to="{ name: 'postDetail', params: { id: curCid, pid: nextPid } }"
              flat
              icon
              color="clr-black"
              ><v-icon>mdi-chevron-right</v-icon></v-btn
            >
            <span>{{ $T('post.arrow.next') }}</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              :disabled="!nextTodoPid"
              slot="activator"
              :to="{ name: 'postDetail', params: { id: curCid, pid: nextTodoPid } }"
              flat
              icon
              color="clr-black"
              ><v-icon>mdi-chevron-double-right</v-icon></v-btn
            >
            <span>{{ $T('post.arrow.next_todo') }}</span>
          </v-tooltip>
        </div>
      </div>
    </div>

    <confirm-dialog
      v-if="dialog.delete"
      ref="deleteConfirm"
      :open="dialog.delete"
      :dialogKey="'delete'"
      :confirmValue="1"
      :persistent="false"
      danger
      :dialogTitle="$T('post.delete.title')"
      :dialogText="$T('post.delete.msg')"
      @ok="onDeleteConfirmed"
      @cancel="dialog.delete = false"
    />
  </div>
</template>

<script>
import { COMMIN } from '../../constant';
import UTILS from '../../utils/utils';
import store from '../../store';
import postPlugin from '../../utils/plugin/postPlugin';
import { deletePost } from '../../api/post';
import postAnswers from './PostAnswers.vue';
import postDetailNews from './PostDetailNews.vue';
import postDetailFile from './PostDetailFile.vue';
import postDetailSchedule from './PostDetailSchedule.vue';
import postDetailEnquete from './PostDetailEnquete.vue';
import postDetailLife from './PostDetailLife.vue';
import postDetailAccept from './PostDetailAccept.vue';
import postDetailFriendAccept from './PostDetailFriendAccept.vue';
import postDetailInvited from './PostDetailInvited.vue';
import postDetailFriendInvited from './PostDetailFriendInvited.vue';

export default {
  mixins: [postPlugin],
  components: {
    'post-answers': postAnswers,
    'post-detail-news': postDetailNews,
    'post-detail-file': postDetailFile,
    'post-detail-schedule': postDetailSchedule,
    'post-detail-enquete': postDetailEnquete,
    'post-detail-life': postDetailLife,
    'post-detail-accept': postDetailAccept,
    'post-detail-friend-accept': postDetailFriendAccept,
    'post-detail-invited': postDetailInvited,
    'post-detail-friend-invited': postDetailFriendInvited,
  },
  props: ['commonPost', 'commonPosts', 'friends'],
  mounted() {
    this.initPost(this.post, this.commonPosts);
  },
  data: function() {
    return {
      post: this.commonPost,
      allPosts: this.commonPosts,
      dialog: {
        delete: false,
      },
      shareTargets: null,
      onlyCreator: false,
      includeInactive: false,
      curFriends: this.friends || {},
    };
  },
  watch: {
    post(n, o) {
      if (n.id == o.id) {
        this.initPost(n, this.allPosts);
      }
    },
    commonPost(n, o) {
      this.post = n;
    },
    commonPosts(n, o) {
      this.initPost(this.post, n);
    },
    stateLastRefreshedId(n, o) {
      if (!n || n != this.post.id) return;
      const cdb = this.$commin.clientdb;
      cdb.getObject('posts', posts => {
        for (const p of posts) {
          if (p.id == this.post.id) {
            this.post = p;
            return;
          }
        }
      });
    },
  },
  computed: {
    pid() {
      return Number(this.$route.params.pid);
    },
    cid() {
      return this.post ? this.post.community_id : 0;
    },
    cmid() {
      return this.post ? this.cidToCmid(this.post.community_id) : 0;
    },
    stateLastRefreshedId() {
      return this.$store.state.post.lastRefreshedId;
    },
    posts() {
      var fps = this.allPosts;
      if (!fps) return [];
      if (!this.curCid) return fps;
      return fps.filter(p => {
        return p.community_id == this.curCid;
      });
    },
    idx() {
      var ps = this.posts;
      for (var i = 0, n = ps.length; i < n; i++) {
        if (ps[i].id == this.pid) return i;
      }
      return -1;
    },
    nextPid() {
      var idx = this.idx;
      var ps = this.posts;
      if (idx == -1) return 0;
      if (this.posts.length > idx + 1) return ps[idx + 1].id;
      return 0;
    },
    nextTodoPid() {
      var idx = this.idx;
      var ps = this.posts;
      if (idx == -1) return 0;
      for (var i = idx + 1, n = ps.length; i < n; i++) {
        if (!this.$utils.isPostCompleted(ps[i])) return ps[i].id;
      }
      return 0;
    },
    prevPid() {
      var idx = this.idx;
      var ps = this.posts;
      if (idx <= 0) return 0;
      return ps[idx - 1].id;
    },
    prevTodoPid() {
      var idx = this.idx;
      var ps = this.posts;
      if (idx <= 0) return 0;
      for (var i = idx - 1; 0 <= i; i--) {
        if (!this.$utils.isPostCompleted(ps[i])) return ps[i].id;
      }
      return 0;
    },
    icon() {
      return this.$utils.postCodeToIcon(this.post.type);
    },
    title() {
      return this.postTitle(this.post);
    },
    isCreator() {
      return this.post && this.post.creator_cmid == this.cmid;
    },
    editable() {
      return this.isCreator && ['JI', 'JA', 'FI', 'FA'].indexOf(this.post.type) == -1;
    },
    deletable() {
      return this.editable;
    },
    maxNameWidth() {
      var w = 300;
      if (this.geMax) w = 358;
      else if (this.gePc) w = this.w - 550 - 207;
      else if (this.leSp) w = this.w - 187;
      else if (this.leTbS) w = this.w - 307;
      else if (this.leTb) w = this.w - 250 - 207;
      return `max-width: ${w}px;`;
    },
  },
  methods: {
    initPost(post, posts) {
      this.dialog.deleteConfitm = false;
      this.dialog.edit = false;
      this.shareTargets = null;
      this.onlyCreator = false;

      var hasPosts = !!posts;
      if (!posts) {
        posts = [post];
      } else {
        posts = this.$utils.mergePost(posts, post);
      }

      this.allPosts = posts;
      this.initShareTarget(post);
    },
    initShareTarget(post) {
      if ('JI' == post.type) {
        this.shareTargets = [`m${post.creator_cmid}`, `m${this.cmid}`];
        this.onlyCreator = false;
        this.includeInactive = true;
        return;
      }
      if ('JA' == post.type) {
        this.shareTargets = [`m${post.creator_cmid}`, `A2`];
        this.onlyCreator = false;
        this.includeInactive = true;
        return;
      }
      if ('FI' == post.type) {
        this.shareTargets = [`m${post.creator_cmid}`, `m${this.cmid}`];
        this.onlyCreator = false;
        this.includeInactive = true;
        return;
      }
      if ('FA' == post.type) {
        this.shareTargets = [`m${post.creator_cmid}`];
        this.onlyCreator = false;
        this.includeInactive = true;
        return;
      }
      this.shareTargets = null;
      this.onlyCreator = true;
      this.includeInactive = false;
    },
    onEditClicked() {
      this.$store.commit('POST_EDIT_DIALOG_OPEN', { code: this.post.type, pid: this.post.id, share: this.post.share });
    },
    onModified(post) {
      if (this.post.id == post.id) this.post = post;
      var self = this;
      this.$commin.clientdb.getObject('posts', function(posts) {
        var newPosts = self.$utils.mergePost(posts ? posts : self.allPosts, post);
        self.allPosts = newPosts;
        self.$commin.clientdb.putObject('posts', newPosts, post);
        self.$store.commit('POST_COUNT_TODO', newPosts);
        self.$emit('postsUpdated', newPosts);
      });
    },
    onDeleteClicked() {
      this.dialog.delete = true;
    },
    onDeleteConfirmed() {
      var self = this;
      deletePost(this.pid)
        .then(function(response) {
          $commin.clientdb.getObject('posts', function(posts) {
            // if no data incache, do nothing.
            if (posts) {
              posts = UTILS.removePost(posts, self.pid);
              $commin.clientdb.putObject('posts', posts);
            }
            self.shortMsg($T('post.delete.notify'));
            self.$refs.deleteConfirm.closeDialog();
            self.$router.push({ name: 'topHome', params: { id: self.curCid } });
          });
        })
        .catch(function(e) {
          console.error(e);
          self.errDeleteData();
        });
    },
    async onMemberRequested() {
      this.shareTargets = await this.getShareTargets(this.pid);
    },
  },
};
</script>

<style scoped>
.c-home {
  position: relative;
}
.c-header-wrap {
  position: sticky;
  top: 79px;
  z-index: 5;
  height: 60px;
  background-color: #fff;
  z-index: 5;
}
.le-tbs .c-header-wrap {
  position: fixed;
  top: 48px;
  left: 0;
  right: 0;
  height: 48px;
  width: 100%;
}
.content-area {
  overflow-y: visible !important;
  overflow-x: hidden !important;
  background-color: #fff;
  min-height: calc(100vh - 330px);
  padding: 0 30px;
}
.le-tbs .content-area {
  min-height: calc(100vh - 108px);
  padding: 48px 25px 110px 25px;
}
.post-control-area {
  background-color: #fff;
  height: 110px;
  width: 100%;
  position: relative;
}
.le-tbs .post-control-area {
  position: fixed;
  bottom: 60px;
  left: 0;
}
.post-control-main {
  padding: 8px 8px 0 8px;
}
.c-prev-next {
  position: absolute;
  bottom: 2px;
  left: 0;
}

.c-post-icon {
  width: 30px !important;
  height: 30px !important;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.c-post-icon img {
  width: 30px !important;
  height: 30px !important;
}
.c-post-name {
  font-weight: 600;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.28);
  font-size: 18px;
  padding-left: 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: hand;
  cursor: pointer;
}
.c-btn-edit {
  margin-right: -10px;
}
.c-edit-btn i {
  font-size: 20px;
}
.c-btn-menu {
  margin-right: 5px;
  margin-left: -10px;
}

.c-mems {
  margin: -3px 0 2px 0;
}
.c-t {
  text-align: right;
  margin-bottom: 3px;
  font-size: 14px;
}
.le-sp .c-t {
  font-size: 12px;
}
.c-expire {
  font-size: 12px;
  margin-top: 5px;
}
.le-sp .c-expire {
  font-size: 11px;
  margin-top: 6px;
}
.c-expire i {
  font-size: 14px;
}
.c-ans {
  margin: 4px 0 0 3px;
}
</style>
